import React, { Dispatch } from "react";
import { CookieConsentAction } from "./CookieConsent";
import { useTranslation } from "react-i18next";
import Snackbar from "../shared/Snackbar";

type Props = {
  dispatch: Dispatch<CookieConsentAction>;
};

const CookiePopup = ({ dispatch }: Props) => {
  const { t } = useTranslation();

  return (
    <Snackbar
      title={t("cookies.title")}
      text={t("cookies.content")}
      buttonLabel={t("cookies.accept")}
      buttonDeclineLabel={t("cookies.decline")}
      onClick={() => dispatch({ type: "accept" })}
      onClickDecline={() => dispatch({ type: "decline" })}
      settings={t("cookies.settings")}
    />
  );
};

export default CookiePopup;
